module.exports = __webpack_public_path__ + "img/full2-min.113ecad8.png";